module.exports = __webpack_public_path__ + "static/media/River Clean.78aec714.png";